<template>
	<div>
		<h1>Animation</h1>
		<div>
			1:<br>
			y {{ this.y }}
			<input type="number" v-model="y" @change="change" @keyup="change">
			x {{ this.x }}
			<input type="number" v-model="x" @change="change" @keyup="change">
			rotation
			<input type="number" v-model="rotation" @change="change" @keyup="change">
		</div>
		<div>2:<br>
			y2 {{ this.y2 }}
			<input type="number" v-model="y2" @change="change" @keyup="change">
			x2 {{ this.x2 }}
			<input type="number" v-model="x2" @change="change" @keyup="change">
			rotation
			<input type="number" v-model="rotation2" @change="change" @keyup="change">
		</div>
		<svg id="svg" ref="svg"></svg>
	</div>
</template>

<script>

	import SVG from 'svg.js';

	export default {
		mounted() {

			var draw = SVG('svg');
			var scale = 3.75;

			var logoWidth = 140 * scale;
			var logoHeight = 60 * scale;

			// draw pink square
		    // draw.rect(100,100).animate().fill('#f03').move(100,100)
			// draw.rect(100, 100).move(100, 50).fill('#f06')
			// draw.move(100, 50).path('M0 0 H50 A20 20 0 1 0 100 50 v25 C50 125 0 85 0 85 z')
			// var s = Snap("#svg");
			// var bigCircle = s.circle(150, 150, 100);
			this.width = this.$refs.svg;
			var logo = draw.group();
			logo.scale(scale);
			logo.transform({
				x: this.$refs.svg.getBoundingClientRect().width/2 - logoWidth/2,
				y: this.$refs.svg.getBoundingClientRect().height/2 - logoHeight/2
			})

			var ceh = logo.group()
				.addClass('ceh-letters');
			var mask = logo
				.rect(146, 70)
				.attr('x', -4)
				.attr('y', -6)
				.addClass('mask')
				.fill('#fff');
			ceh.maskWith(mask);

		    /* C */
			ceh.fill('#264573')
			   .path(`M23.523,58.422c10.965,0,19.375-6.443,21.746-16.527H35.193c-1.967,4.945-6.207,7.764-11.738,7.764
				c-8,0-13.807-6.035-13.807-14.35c0-8.316,5.807-14.354,13.807-14.354c6.129,0,10.674,3.496,12.295,9.4h9.852
				c-1.805-11.072-10.357-18.162-22.078-18.162C9.893,12.193,0,21.914,0,35.309C0,48.701,9.893,58.422,23.523,58.422z`);

		    /* E */
		    ceh.rect(33.014,5.688).fill('#264573').move(53.402,0)
			ceh.polygon(`86.416,21.16 86.416,13.146 53.402,13.146 53.402,57.469 86.416,57.469 86.416,49.455 
				62.914,49.455 62.914,39.834 86.416,39.834 86.416,38.834 86.416,31.322 86.416,30.873 62.914,30.873 62.914,21.16 `)
				.fill('#264573')

		    /* H */
			ceh.polygon(`123.152,13.146 123.152,30.873 104.162,30.873 104.162,13.146 94.648,13.146 94.648,57.469 
				104.162,57.469 104.162,39.834 123.152,39.834 123.152,57.469 132.665,57.469 132.665,13.146 `)
				.fill('#264573')

			/* PLUS + */
			// draw.polygon(`181.845,30.873 164.868,30.873 164.868,13.146 155.64,13.146 155.64,30.873 138.665,30.873 
			// 	138.665,40.1 155.64,40.1 155.64,56.326 164.868,56.326 164.868,40.1 181.845,40.1 `)
			// 	.fill('#30C3E5')

			var plusHoekMove1 = logo.group()
				.addClass('plus-hoek-group-1')
			this.plusHoek1 = plusHoekMove1.polygon(`164.868,13.146 155.64,13.146 155.64,30.873 138.665,30.873 138.665,40.1 164.868,40.1 `)
				.addClass('plus-hoek-1')
				.fill('#30C3E5')
			// this.plusHoek1
			// 		.transform({
			// 			rotation: this.rotation,
			// 			x: `${+this.x}px`,
			// 			y: `${+this.y}px`
			// 		})
					// .rotate(this.rotation)
					// .move(10, 50);
				// .animate().rotate(0).move(100, 100)
				// .delay(750).animate().dmove(50,50)
				// .delay(1500).animate().dmove(-10,0)

			var plusHoekMove2 = logo.group()
				.addClass('plus-hoek-group-2')
			this.plusHoek2 = plusHoekMove2.polygon(`181.845,30.873 155.64,30.873 155.64,56.326 164.868,56.326 164.868,40.1 181.845,40.1 `)
				.addClass('plus-hoek-2')
				.fill('#30C3E5')
			// this.plusHoek2
					// .transform({
					// 	rotation: this.rotation,
					// 	x: `${+this.x}px`,
					// 	y: `${+this.y}px`
					// })
					// .rotate(this.rotation)

			var valueSystem = [
				`M8.152,68.281l-2.986,7.113H4.434l-2.986-7.113h0.672l2.678,6.273l2.68-6.273H8.152z`,
				`M12.033,68.281l3.023,7.113h-0.691l-0.957-2.217H9.93l-0.957,2.217H8.281l3.023-7.113H12.033z M11.672,69.051l-1.48,3.477h2.955L11.672,69.051z`,
				`M17.229,68.281v6.494h3.439v0.619h-4.094v-7.113H17.229z`,
				`M26.922,68.281h0.662v4.494c0,1.461-1.186,2.711-2.795,2.711c-1.605,0-2.791-1.25-2.791-2.711v-4.494 h0.666v4.424c0,1.191,0.945,2.139,2.125,2.139c1.184,0,2.131-0.947,2.133-2.139V68.281z`,
				`M33.756,68.281v0.611h-3.572v2.502h3.533v0.611h-3.533v2.777h3.609v0.611h-4.26v-7.113H33.756z`,
				`M40.781,71.943c-1.113-0.297-1.871-0.904-1.871-1.885c0-1.266,1.023-1.877,2.072-1.875 c0.617,0,1.24,0.205,1.652,0.598l-0.408,0.447c-0.322-0.291-0.793-0.436-1.244-0.42c-0.717,0.02-1.4,0.42-1.4,1.23 c0,0.67,0.482,1.09,1.424,1.361l0.506,0.156c1.01,0.326,1.615,0.93,1.615,1.994c0,1.225-1.049,1.908-2.188,1.932 c-0.76,0.018-1.551-0.254-2.078-0.824l0.408-0.465c0.436,0.482,1.066,0.688,1.654,0.662c0.82-0.031,1.561-0.508,1.561-1.305 c0-0.764-0.406-1.158-1.246-1.453L40.781,71.943z`,
				`M49.992,68.281l-2.639,4.133v2.98h-0.65v-2.977l-2.629-4.139h0.719l2.238,3.518l2.246-3.516H49.992z`,
				`M53.092,71.943c-1.115-0.297-1.873-0.904-1.873-1.885c0-1.266,1.023-1.877,2.074-1.875 c0.617,0,1.238,0.205,1.65,0.598l-0.406,0.447c-0.322-0.291-0.793-0.436-1.244-0.42c-0.719,0.02-1.402,0.42-1.402,1.23 c0,0.67,0.484,1.09,1.424,1.361l0.506,0.156c1.012,0.326,1.615,0.93,1.615,1.994c0,1.225-1.047,1.908-2.188,1.932 c-0.758,0.018-1.551-0.254-2.076-0.824l0.406-0.465c0.436,0.482,1.068,0.688,1.656,0.662c0.82-0.031,1.561-0.508,1.561-1.305 c0-0.764-0.408-1.158-1.248-1.453L53.092,71.943z`,
				`M61.363,68.281v0.611h-2.164v6.502h-0.65v-6.498h-2.166v-0.615H61.363z`,
				`M67.109,68.281v0.611h-3.572v2.502h3.533v0.611h-3.533v2.777h3.609v0.611h-4.26v-7.113H67.109z`,
				`M75.787,68.281v7.113h-0.65v-6.211l-2.865,3.588l-2.863-3.592v6.215h-0.65v-7.113h0.732l2.781,3.537 l2.783-3.537H75.787z`,
			];

			// valueSystem.forEach((letter, i) => {
			// 	setTimeout(() => {
			// 		console.log('letter');
			// 		draw.path(letter) // .delay(i*50)
			// 	}, i*500);
			// })

			/*

			1
			y 62
			x 222
			180

			2
			80
			241
			180

			1
			y 30
			x 150
			180

			2
			106
			312
			180

			*/
/*
			this.plusHoek1
				.rotate(180)
				.translate(222, 62)
			this.plusHoek2
				.rotate(180)
				.translate(241, 80)

			setTimeout(() => {
				this.plusHoek1
					.animate(3000)
					.rotate(180)
					.move(-100, 0)
					// .translate(150, 30)
				this.plusHoek2
					.animate(3000)
					.rotate(180)
					// .translate(312, 106)
			}, 2000)
*/
			// setTimeout(() => {
			// 	this.plusHoek1
			// 		.rotate(0)
			// 		.translate(0, 0)
			// 	this.plusHoek2
			// 		.rotate(0)
			// 		.translate(0, 0)
			// }, 4000)

		},
		methods: {
			change() {
				
				this.plusHoek1
					.transform({
						rotation: this.rotation,
					})
					.translate(+this.x, +this.y)
					// .animate()
					// .move(+this.x || 0, +this.y || 0)
					// .rotate(+this.rotation || 0);
				this.plusHoek2
					.rotate(this.rotation2)
					.translate(+this.x2, +this.y2)
					// .move(+this.x2 || 0, +this.y2 || 0)
					// .rotate(+this.rotation2 || 0);
				
			}
		},
		data() {
			return {
				x: 222,
				x2: 62,
				y: 241,
				y2: 80,
				rotation: 0,
				rotation2: 0,
				plusHoek1: {},
				plusHoek2: {}
			}
		}
	}
</script>

<style lang="scss">

	.plus-hoek-group-1 {
	    animation: move1 4s infinite;
	    transform-origin: 152px 27px;
	    border: 1px solid red;
	}
	.plus-hoek-1 {
	    animation: rotate1 4s infinite;
	    transform-origin: 152px 27px;
	}

	.plus-hoek-group-2 {
	    animation: move2 4s infinite;
	    transform-origin: 152px 27px;
	    border: 1px solid red;
	}
	.plus-hoek-2 {
	    animation: rotate2 4s infinite;
	    transform-origin: 152px 27px;
	}
	.mask {
	    animation: mask 4s infinite;
	    transform-origin: 80px 30px;
	}

	.ceh-letters {
	    animation: ceh 4s infinite;
	}

	@keyframes move1 {
		25% { transform: translate(-72px, 0px); }
	    25% { transform: translate(-72px, 0px); }
	    50% { transform: translate(-150px, -30px); }
	    75% { transform: translate(0px, 0px); }
	    100% { transform: translate(0px, 0px); }
	}

	@keyframes rotate1 {
		25% {transform: rotate(180deg);}
	    25% {transform: rotate(180deg);}
	    50% {transform: rotate(180deg);}
	    75% {transform: rotate(0deg);}
	    100% {transform: rotate(0deg);}
	}

	@keyframes move2 {
		25% { transform: translate(-72px, 0px); }
	    25% { transform: translate(-72px, 0px); }
	    50% { transform: translate(5px, 50px); }
	    75% { transform: translate(0px, 0px); }
	    100% { transform: translate(0px, 0px); }
	}

	@keyframes rotate2 {
		25% {transform: rotate(180deg); }
	    25% {transform: rotate(180deg); }
	    50% {transform: rotate(180deg); }
	    75% {transform: rotate(0deg); }
	    100% {transform: rotate(0deg); }
	}

	@keyframes mask {
		25% {transform: scale(0); }
	    25% {transform: scale(0); }
	    50% {transform: scale(1); }
	    75% {transform: scale(1); }
	    100% {transform: scale(1); }
	}

	@keyframes ceh {
		25% {opacity: 0; }
	    25% {opacity: 0; }
	    50% {opacity: 1; }
	    75% {opacity: 1; }
	    100% {opacity: 1; }
	}

	body {
		overflow: hidden;
	}

	#svg {
		background-color: #fff;
		position: fixed;
		z-index: 99999;
		height: 100vh;
		width: 100vw;
		left: 0;
		top: 0;

		.plus-hoek-1 {
			&:hover {
				transform: rotate(180deg);
				margin-left: 10px;
				transition: all 300ms;
			}
		}

		.plus-hoek-2 {
			&:hover {
				transform: translate(100px, 100px) rotate(180deg);
				margin-left: 10px;
				transition: all 300ms;
			}
		}
	}
</style>